module.exports = __webpack_public_path__ + "static/media/fifi.0c69c675.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fifi.png
// module id = 43
// module chunks = 0